"use strict";
export const migration3 = (state) => {
  if (state?.user) {
    return {
      ...state,
      _persist: {
        ...state._persist,
        version: 3
      }
    };
  }
  return state;
};
